/**
 * 리뉴얼 코치로 라우팅
 */
export const routeToRenewalCoach = () => {
  const renewalCoachUrl = process.env.NEXT_PUBLIC_RENEWAL_COACH_URL || ''

  window.location.href = renewalCoachUrl
}
